var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGroup = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 27,
  height: 27,
  viewBox: "0 0 27 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M26.2609 6.06986L0.258911 6.06986L0.258911 21.8568C0.258911 23.0883 0.748106 24.2693 1.61888 25.1401C2.48965 26.0108 3.67067 26.5 4.90213 26.5H21.6177C22.8492 26.5 24.0302 26.0108 24.901 25.1401C25.7717 24.2693 26.2609 23.0883 26.2609 21.8568V6.06986Z",
  fill: "url(#paint0_linear_4117_3171)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M26.2611 7.82944L0.259033 7.82944L0.259033 22.2566C0.259033 23.382 0.748228 24.4613 1.619 25.2571C2.48977 26.0528 3.67079 26.4999 4.90225 26.4999H21.6178C22.8493 26.4999 24.0303 26.0528 24.9011 25.2571C25.7719 24.4613 26.2611 23.382 26.2611 22.2566V7.82944Z",
  fill: "url(#paint1_linear_4117_3171)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M26.2608 5.14316C26.2608 3.91171 25.7716 2.73069 24.9009 1.85991C24.0301 0.989141 22.8491 0.499947 21.6176 0.499947H4.90204C3.67058 0.499947 2.48956 0.989141 1.61879 1.85991C0.748014 2.73069 0.25882 3.91171 0.25882 5.14316V7.92909H26.2608V5.14316Z",
  fill: "url(#paint2_linear_4117_3171)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_4117_3171",
  x1: 9.54535,
  y1: 6.06986,
  x2: 16.0459,
  y2: 26.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B3E0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8CD0FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_4117_3171",
  x1: 13.26,
  y1: 15.4674,
  x2: 14.8968,
  y2: 52.5461,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0643F8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_4117_3171",
  x1: 12.4838,
  y1: 0.778466,
  x2: 12.6853,
  y2: 22.7453,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1B2D49"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0643F8"
})))));
export { SvgGroup as ReactComponent };
export default __webpack_public_path__ + "static/media/group.2ad64db3.svg";